/* eslint-disable react/jsx-no-target-blank */
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'

import {Fragment, useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useLayout} from '../../core'
import {getDefaultRegion} from '../../../../app/pages/UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import {REGION} from '../../../../app/Utils/Constant/ConstantForWebsite'
import {setSelectedDashboard} from '../../../../app/Redux/FrontEnd/ProDashboardSlices/ProDashboardSlice'
import useAsideMenuMainHooks from './useAsideMenuMainHooks'
import {useGetAccessToProductQuery, useGetProductQuery} from '../../../../services/cellcast.v2'
import {WalletCardNotActivate as WalletCardNotActivateV1} from '../../../../app/Utils/Constant/ArrayOfSideNav'
const bCardHiddenMenu = [
  'File Scheduler',
  'Landing Pages',
  'File Scheduled',
  'Purchase Credit',
  'Custom opt-out',
  'Lead Capture Form',
  'My Account',
  `Register Sender ID's`,
  'Dedicated Numbers',
  'Integrations',
  'Settings',
  'Wallet/card Templates',
]

const SectionHeader = ({label}: {label: string}) => (
  <div className='menu-item'>
    <div className='menu-content pt-2 pb-2'>
      <span
        className='menu-section text-muted text-uppercase fs-6.5 ls-1'
        style={{fontWeight: 600}}
      >
        {label}
      </span>
    </div>
  </div>
)

const getMoreMenu = (
  isDefaultRegion: boolean,
  userRegion: string,
  More: any[],
  MoreRegion: any[]
) => {
  let menu = isDefaultRegion ? More : MoreRegion

  if (userRegion === REGION.UK) {
    menu = (menu ?? [])
      .filter((it: any) => it?.title !== 'Dedicated Numbers')
      .map((it: any) => {
        if (it.subMenu && typeof it.fontIcon === 'undefined') {
          return {...it, fontIcon: ''}
        }
        return it
      })
  }

  return menu
}

export function AsideMenuMain() {
  const dispatch = useDispatch()
  const data: any = localStorage.getItem('permission')
  const userPermissions = JSON.parse(data)
  const {setQuickMessagePopup} = useLayout()
  const userRegion = useSelector(getDefaultRegion)

  const {userData, isDefaultRegion, isAdmin, getNavigation, newNavigation} = useAsideMenuMainHooks()
  const {
    Campaign,
    CampaignRegion,
    More,
    MoreRegion,
    Tools,
    ToolsRegion,
    WalletCard,
    backEndMenu,
    LeadManagement,
    Capture,
    Engagement,
    Convert,
    System,
    WalletCardNotActivate,
  } = getNavigation()

  // ---- Derived Menus ----
  const campaignMenu = isDefaultRegion ? Campaign : CampaignRegion
  const toolsMenu = isDefaultRegion ? Tools : ToolsRegion
  const moreMenu = getMoreMenu(isDefaultRegion, userRegion, More, MoreRegion)

  const Navlist = isAdmin === 'true' ? backEndMenu : campaignMenu

  const [isShowCredit, setIsShowCredit] = useState(true)
  const [isShowWalletCard, setIsShowWalletCard] = useState(false)

  const handleSelectDashboard = (value: string) => {
    dispatch(setSelectedDashboard(value))
  }

  const hasPermission = (perm: string) => userPermissions?.includes(perm) || perm === 'all'

  useEffect(() => {
    if (userData && userData.subClientAccountId && userData.subClientAccountId !== '') {
      if (userData._id !== userData.ownerId) {
        setIsShowCredit(false)
      }
    }
  }, [userData])

  /** BCARD subscription */
  const {data: productData} = useGetProductQuery({
    productKey: 'bcard',
  })

  const productId = productData?.data?.product?._id || ''

  const {data: accessToProduct} = useGetAccessToProductQuery({productId}, {skip: !productId})
  const dataAccessToProduct = accessToProduct?.data

  const isAccessWalletCard = dataAccessToProduct?.hasAccess

  let filterCaptureWalletCard: any[] = [...Capture]
  if (!isAccessWalletCard && newNavigation) {
    filterCaptureWalletCard = filterCaptureWalletCard.filter(
      (item: any) => item.title !== 'AI B-Cards'
    )
    filterCaptureWalletCard = [...WalletCardNotActivateV1, ...filterCaptureWalletCard]
  }

  /* END BCARD subscription */
  const shouldHideMenu = (title: string) => {
    if (!userData) return false
    const hasWalletCard = userData.features?.includes('Wallet Card')
    const isBCardMenu = bCardHiddenMenu.includes(title)
    const isFEstaffWithBCard = userData.role === 'FEstaff' && userData.tagNames?.includes('B-card')
    return hasWalletCard && isBCardMenu && isFEstaffWithBCard
  }

  useEffect(() => {
    if (userData) {
      const allowWalletCard =
        userData &&
        userData?.features?.includes('Wallet Card') &&
        userData?.tagNames?.includes('B-card')

      setIsShowWalletCard(allowWalletCard)
    }
  }, [userData])

  // Recursive renderer for menu items (supports 3+ levels)
  const renderMenuItemRecursive = (item: any, level = 0) => {
    if (
      shouldHideMenu(item.title) ||
      !hasPermission(item.Permissions) ||
      (item.title === 'Purchase' && !isShowCredit)
    ) {
      return null
    }

    const handleClick = () => {
      if (item.title === 'Quick Message') {
        setQuickMessagePopup(true)
      }
    }

    const hasChildren = Array.isArray(item.subMenu) && item.subMenu.length > 0

    if (!hasChildren) {
      return (
        <AsideMenuItem
          key={item.title}
          to={item.to}
          title={item.title}
          icon={item.icon}
          fontIcon={item.fontIcon}
          hasBullet={item?.hasBullet}
          parent={item?.parent}
          exactUrl={['Auto Top-up', 'Billing History', 'Cards'].includes(item.title)}
          onClick={handleClick}
          level={level}
          newNavigation={newNavigation}
        />
      )
    }

    return (
      <AsideMenuItemWithSub
        key={item.title}
        to={item.to}
        title={item.title}
        icon={item.icon}
        fontIcon={item.fontIcon}
        hasBullet={item?.hasBullet}
        parent={item?.parent}
      >
        {item.subMenu.map((sub: any) => renderMenuItemRecursive(sub, level + 1))}
      </AsideMenuItemWithSub>
    )
  }

  const renderMenuList = (menu: any[]) => menu.map((item) => renderMenuItemRecursive(item))

  const isMoreMenuShow = moreMenu.some((item) => !shouldHideMenu(item.title))

  const floatingItems = ['Settings']
  const bottomMoreMenu = newNavigation
    ? moreMenu?.filter((m: any) => !floatingItems.includes(m.title))
    : moreMenu
  const floatingMoreMenu = moreMenu?.filter((m: any) => floatingItems.includes(m.title))

  return (
    <div className={newNavigation ? 'd-flex flex-column justify-content-between h-100' : ''}>
      <div>
        {/* Dashboard */}
        {isAdmin === 'false' ? (
          <div
            style={
              newNavigation ? {position: 'sticky', top: 0, zIndex: 10, background: '#fff'} : {}
            }
          >
            <AsideMenuItemWithSub
              to='/dashboard'
              icon='/media/icons/duotune/general/gen008.svg'
              title='Dashboard'
              fontIcon='bi-app-indicator'
              newNavigation={newNavigation}
            >
              {[
                {label: 'Pro Dashboard', value: 'dashboard-1'},
                {label: 'Leads Dashboard', value: 'dashboard-leads'},
                {label: 'Starter Dashboard', value: 'dashboard-pro'},
              ].map((item) => (
                <AsideMenuItem
                  key={item.value}
                  to='/'
                  title={item.label}
                  fontIcon='bi-app-indicator'
                  onClick={() => handleSelectDashboard(item.value)}
                  exactUrl
                />
              ))}
            </AsideMenuItemWithSub>
          </div>
        ) : (
          <AsideMenuItem
            to='/dashboard'
            icon='/media/icons/duotune/general/gen008.svg'
            title='Dashboard'
            exactUrl
          />
        )}

        {newNavigation && hasPermission('manage-sub-client-user') && (
          <AsideMenuItem
            to={'/subAccount/user'}
            title={'Sub Client Accounts'}
            icon='/media/icons/duotune/communication/com014.svg'
            exactUrl
          />
        )}

        {newNavigation && renderMenuList(LeadManagement)}

        {/* Campaign */}
        {isAdmin === 'false' && Navlist?.length > 0 && (
          <SectionHeader label={!newNavigation ? 'Campaign' : ''} />
        )}
        {renderMenuList(Navlist)}

        {/* Tools */}
        {isAdmin === 'false' && toolsMenu?.length > 0 && <SectionHeader label='Tools' />}
        {isAdmin === 'false' && renderMenuList(toolsMenu)}

        {/* Wallet / Card */}
        {isAdmin === 'false' &&
          isShowWalletCard &&
          !isAccessWalletCard &&
          WalletCardNotActivate?.length > 0 && <SectionHeader label='Wallet / Card' />}

        {isAdmin === 'false' &&
          isShowWalletCard &&
          !isAccessWalletCard &&
          WalletCardNotActivate?.length > 0 &&
          renderMenuList(WalletCardNotActivate)}

        {isAdmin === 'false' &&
          isShowWalletCard &&
          isAccessWalletCard &&
          WalletCard?.length > 0 && <SectionHeader label='Wallet / Card' />}

        {isAdmin === 'false' &&
          isShowWalletCard &&
          isAccessWalletCard &&
          WalletCard?.length > 0 &&
          renderMenuList(WalletCard)}

        {/* New Navigation: Engagement, Capture, Convert, System */}
        {isAdmin === 'false' &&
          [
            {label: 'Capture', data: filterCaptureWalletCard},
            {label: 'Engagement', data: Engagement},
            {label: 'Convert', data: Convert},
          ].map(
            ({label, data}) =>
              data?.length > 0 && (
                <Fragment key={label}>
                  <SectionHeader label={label} />
                  {renderMenuList(data)}
                  <SectionHeader label={''} />
                </Fragment>
              )
          )}
      </div>

      {/* More
      {isAdmin === 'false' && isMoreMenuShow && (moreMenu?.length > 0) && <SectionHeader label='More' />}
      {isAdmin === 'false' && renderMenuList(moreMenu)} */}

      <div className={'mb-6'}>
        {/* normal More menu stays above */}
        {isAdmin === 'false' && isMoreMenuShow && bottomMoreMenu?.length > 0 && (
          <>
            <SectionHeader label='More' />
            {renderMenuList(bottomMoreMenu)}
          </>
        )}

        {isAdmin === 'false' && newNavigation && System?.length > 0 && (
          <>{renderMenuList(System)}</>
        )}

        {/* floating bottom (sticky) */}
        {isAdmin === 'false' && newNavigation && floatingMoreMenu?.length > 0 && (
          <div className='mt-auto'>{renderMenuList(floatingMoreMenu)}</div>
        )}
      </div>
    </div>
  )
}
